import { Injectable } from '@angular/core';
import {
  CardPaymentMethods,
  NonCardPaymentMethods,
} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodNameService {
  constructor() { }

  getName(paymentMethod: string, subprocessor: string | null = null): string {
    if (paymentMethod == CardPaymentMethods.BR_DGE) {
      return subprocessor;
    }

    if (
      paymentMethod == CardPaymentMethods.FIRSTDATA ||
      paymentMethod == CardPaymentMethods.CASHFLOWS ||
      paymentMethod == CardPaymentMethods.TRUSTPAYMENTS ||
      paymentMethod == CardPaymentMethods.CHECKOUT
    ) {
      return 'Debit/Credit Card';
    }
    if (paymentMethod == NonCardPaymentMethods.PAYPAL) {
      return 'PayPal';
    }
    if (paymentMethod == NonCardPaymentMethods.FREE) {
      return 'N/A';
    }
    if (paymentMethod == 'applepay') {
      return 'ApplePay (Debit/Credit Card)';
    }
    if (paymentMethod == 'googlepay') {
      return 'GooglePay (Debit/Credit Card)';
    }

    return 'Unknown';
  }
}
